// extracted by mini-css-extract-plugin
export default {"Button":"MiniButton_Button__6oU29"};